import { render, staticRenderFns } from "./driver-form.vue?vue&type=template&id=f5e0acae&scoped=true&"
import script from "./driver-form.vue?vue&type=script&lang=js&"
export * from "./driver-form.vue?vue&type=script&lang=js&"
import style0 from "./driver-form.vue?vue&type=style&index=0&id=f5e0acae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e0acae",
  null
  
)

export default component.exports